import { render, staticRenderFns } from "./AgoraVideoCall.vue?vue&type=template&id=36da7b06&"
import script from "./AgoraVideoCall.vue?vue&type=script&lang=js&"
export * from "./AgoraVideoCall.vue?vue&type=script&lang=js&"
import style0 from "./AgoraVideoCall.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VIcon,VProgressCircular,VSelect,VSwitch})
